import {
	Dialog,
	DialogContent,
	DialogTitle,
	IconButton,
} from "@mui/material"
import { Close } from "@mui/icons-material"

export function DashboardModal({ open, setClose, title, stylePassThru, children }) {

	return (
		<Dialog
			open={open}
			onClose={() => setClose()}
			maxWidth={"lg"}
			sx={stylePassThru ? stylePassThru : null}
		>
			<IconButton
				onClick={() => setClose()}
				variant={"curved-square"}
				sx={{ position: "absolute", top: 0, right: 0 }}
			>
				<Close />
			</IconButton>
			<DialogTitle
				sx={{ display: "flex", justifyContent: "center", fontWeight: 600 }}
				variant={"h5"}
			>
				{title}
			</DialogTitle>
			<DialogContent
				sx={{
					overflowX: "clip",
					overflowY: "auto",
				}}
			>{children}</DialogContent>
		</Dialog>
	)
}
